export const getYearOptions = (since: number) => {
  const options = [];
  const currentYear = (new Date()).getFullYear();
  for (let year = currentYear + 1; year >= since; year--) {
    options.push({label: `${year}`, value: `${year}`})
  }
  return options
}